var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabaretStyleSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 55,
    fill: "none",
    viewBox: "0 0 67 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.484,
    cy: 15.485,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.008,
    cy: 21.893,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.93,
    cy: 21.893,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.455,
    cy: 15.485,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.203,
    cy: 9.078,
    r: 9.078,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.795,
    cy: 15.485,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.319,
    cy: 21.893,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.242,
    cy: 21.893,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.765,
    cy: 15.485,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.513,
    cy: 9.078,
    r: 9.078,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.173,
    cy: 45.389,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.697,
    cy: 51.796,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.62,
    cy: 51.796,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.144,
    cy: 45.389,
    r: 3.204,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.892,
    cy: 38.981,
    r: 9.078,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabaretStyleSpace);
export default __webpack_public_path__ + "static/media/cabaret-style-space.b4c6a066bfd5942cfd62e72c5710cd33.svg";
export { ForwardRef as ReactComponent };